<script>
export default {
    name: "CashReceipt",

    data() {

        return {
            items: [],
            patient: {},
        };
    },

    computed: {

        total() {

            if(!this.items.length) return 0;

            return this.items.map(item => item.amount ? parseFloat(item.amount) : 0)
                .reduce((sum, amt) => sum +amt);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
                this.fetchPendingPostedBills(), this.fetchPatient(), 
            ]).then(() => {
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
            }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patientId}`;

            return this.$http.get(url).then(({data}) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchPendingPostedBills() {
            const queryString = `?PatientId=${this.$route.query.patientId}`;

            return this.$http.get(`Accounts/GetPatientsPendingpostedBills${queryString}`)
                .then(({data}) => {
                    this.items = data.filter(item => item.allowForService);
                }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="flex-1 my-1 text-center p-1">
        <h5 class="font-bold">ALLOWED SERVICE SLIP</h5>
    </div>
    <div class="flex flex-wrap w-full mt-1 border-t-2 border-gray-400 px-1">
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">Name: {{ patient.names}}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
        </div>
        <div class="flex-1 my-1">
            <h5 class="font-semibold text-sm">Date: 
                {{ items.length ? $root.formatDate(items[0].allowForServiceDate) : `-` }}</h5>
        </div>
        <div class="w-full my-1">
            <h5 class="font-medium text-sm">P Mode: 
                {{ patient.pMode }}</h5>
        </div>
    </div>
    <table class="table mt-1 mx-1">
        <thead class="text-sm border-t-2 border-b-2 border-gray-400">
            <tr>
                <th class="p-tiny">Bill NO</th>
                <th class="p-tiny">Item</th>
                <th class="p-tiny">Qty</th>
                <th class="p-tiny">Amount</th>
                <th class="p-tiny">Memo</th>
            </tr>
        </thead>
        <tbody class="text-xs">
            <tr v-for="(item,idx) in items" :key="idx" class="border-b border-gray-400">
                <td class="p-tiny">{{ item.bill_No }}</td>
                <td class="p-tiny">{{ item.itemName }}</td>
                <td class="p-tiny">{{ item.quantity }}</td>
                <td class="p-tiny">{{ item.amount }}</td>
                <td class="p-tiny break-words">{{ item.allowForServiceComment || `-` }}</td>
            </tr>
            <tr>
                <td colspan="5" class="p-1 text-right">
                    Total: {{ total | numberFormat }}
                </td>
            </tr>
        </tbody>
    </table>
    <div class="w-full my-1 text-right mx-1">
        <h5 class="text-sm">Served By: {{ items.length ? items[0].allowForServiceUser : `` }}</h5>
    </div>
</div>
</template>